import React from 'react';
import { FC } from 'react';

export const Hof: FC = () => {
    return (
        <div>
            <div> 
                <iframe title="Slide" src="https://docs.google.com/presentation/d/e/2PACX-1vSJ1nSv4KDQ7NG2fM3Fe2C8JPzlUQ_a0FDy_v1sjQS-Ar0MBr-PRV4EHkAHage3GBtkHV_hRg_zlUU7/embed?start=false&loop=false&delayms=60000"
                 width="1200" height="675">

                    
                 </iframe>
            </div>
            <form>
                <label>Notes</label>
                <textarea>
                </textarea>
            </form>
        </div>
    )
};